import React from 'react';
import * as S from './ProcessDetailSkeletonStyles';

const ProcessDetailSkeleton = props => (
  <S.Container {...props}>
    <S.Column>
      <S.Group>
        <S.Loader speed={1.3} width={400} height={124} viewBox="0 0 400 124">
          <rect x="0" y="0" rx="8" ry="8" width={328} height={16} />
          <rect x="0" y="28" rx="8" ry="8" width={160} height={16} />
          <rect x="0" y="84" rx="8" ry="8" width={16} height={16} />
          <rect x="24" y="84" rx="8" ry="8" width={160} height={16} />
        </S.Loader>
      </S.Group>

      <S.Group>
        <S.Loader width={400} height={40} viewBox="0 0 400 40" speed={1.3}>
          <rect x="0" y="0" rx="8" ry="8" width={120} height={16} />
          <rect x="0" y="24" rx="8" ry="8" width={328} height={16} />
        </S.Loader>
      </S.Group>

      <S.Group>
        <S.Loader width={400} height={40} viewBox="0 0 400 40" speed={1.3}>
          <rect x="0" y="0" rx="8" ry="8" width={120} height={16} />
          <rect x="0" y="24" rx="8" ry="8" width={328} height={16} />
        </S.Loader>
      </S.Group>

      <S.Group>
        <S.Loader width={400} height={40} viewBox="0 0 400 40" speed={1.3}>
          <rect x="0" y="0" rx="8" ry="8" width={120} height={16} />
          <rect x="0" y="24" rx="8" ry="8" width={328} height={16} />
        </S.Loader>
      </S.Group>

      <S.Group>
        <S.Loader width={400} height={100} viewBox="0 0 400 100" speed={1.3}>
          <rect x="0" y="0" rx="8" ry="8" width={120} height={16} />
          <rect x="0" y="24" rx="8" ry="8" width={328} height={16} />
          <rect x="0" y="60" rx="8" ry="8" width={308} height={16} />
        </S.Loader>
      </S.Group>

      <S.Group>
        <S.Loader width={400} height={80} viewBox="0 0 400 80" speed={1.3}>
          <rect x="0" y="0" rx="8" ry="8" width={120} height={16} />
          <rect x="0" y="24" rx="8" ry="8" width={328} height={16} />
        </S.Loader>
      </S.Group>

      <S.Group>
        <S.Loader width={400} height={80} viewBox="0 0 400 80" speed={1.3}>
          <rect x="0" y="0" rx="8" ry="8" width={120} height={16} />
          <rect x="0" y="24" rx="8" ry="8" width={328} height={16} />
        </S.Loader>
      </S.Group>

      <S.Group>
        <S.Loader width={400} height={50} viewBox="0 0 400 50" speed={1.3}>
          <rect x="0" y="0" rx="8" ry="8" width={120} height={16} />
          <rect x="236" y="0" rx="8" ry="8" width={120} height={16} />
          <rect x="0" y="24" rx="8" ry="8" width={148} height={16} />
          <rect x="236" y="24" rx="8" ry="8" width={148} height={16} />
        </S.Loader>
      </S.Group>
      <S.Group>
        <S.Loader width={400} height={50} viewBox="0 0 400 50" speed={1.3}>
          <rect x="0" y="0" rx="8" ry="8" width={120} height={16} />
          <rect x="236" y="0" rx="8" ry="8" width={120} height={16} />
          <rect x="0" y="24" rx="8" ry="8" width={148} height={16} />
          <rect x="236" y="24" rx="8" ry="8" width={148} height={16} />
        </S.Loader>
      </S.Group>
    </S.Column>
    <S.Column>
      <S.Group>
        <S.Loader width={400} height={16} viewBox="0 0 400 16" speed={1.3}>
          <rect x="0" y="0" rx="8" ry="8" width={120} height={16} />
        </S.Loader>
      </S.Group>

      <S.Box>
        <S.Group noMargin>
          <S.Loader width={400} height={58} viewBox="0 0 400 58" speed={1.3}>
            <rect x="60" y="0" rx="8" ry="8" width={145} height={16} />
            <rect x="60" y="21" rx="8" ry="8" width={116} height={16} />
            <rect x="60" y="42" rx="8" ry="8" width={80} height={16} />
          </S.Loader>
        </S.Group>
      </S.Box>

      <S.Box>
        <S.Group noMargin>
          <S.Loader width={400} height={58} viewBox="0 0 400 58" speed={1.3}>
            <rect x="60" y="0" rx="8" ry="8" width={145} height={16} />
            <rect x="60" y="21" rx="8" ry="8" width={116} height={16} />
            <rect x="60" y="42" rx="8" ry="8" width={80} height={16} />
          </S.Loader>
        </S.Group>
      </S.Box>
    </S.Column>
  </S.Container>
);

export default ProcessDetailSkeleton;
